/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-unused-vars */
/* eslint-disable indent */
import React, { useEffect } from 'react'
import {
  useLocation,
  useHistory,
  useRouteMatch,
  Switch,
  Route,
  useParams,
} from 'react-router-dom'
import { Container } from '@pando-styles/nirvana'

import { StyledHeadingThree, StyledParagraph } from '@styles/index'
import { Tabs } from '@styles/index'
import { Grid } from '@atomic/index'
import {
  getIncompleteSurveyInstances,
  getCompletedSurveyInstances,
  InstanceShort,
} from '@utils/index'
import { VideoResponse } from '@applications/index'

import { tabItems } from './tab-items'
import { IncompleteSurveys, CompletedSurveys } from './components'

const MainTabSurvey: React.FC = () => {
  const { path, url } = useRouteMatch()
  const location = useLocation()
  const navigate = useHistory()

  const component = [
    {
      key: 'complete',
      name: (
        <Grid
          appConfig={{
            storage_key: 'completed-surveys',
            query_entity: 'instances',
            no_data_text: 'No completed surveys at this time.',
            fetching_data_text: 'Fetching completed surveys.',
            enablePagination: true,
            showCurrentPage: false,
            searchFields: ['surveyName', 'surveyDescription'],
            initialState: {
              pageSize: 5,
              sortBy: 'dateCompleted.seconds',
              sortOrder: 'descending',
            },
          }}
          queryParams={{
            resultsPerPage: 5,
            page: 0,
          }}
          actions={{
            onFetch: getCompletedSurveyInstances,
          }}
          customComponent={(item) => <CompletedSurveys {...item} />}
        />
      ),
    },
    {
      key: 'incomplete',
      name: (
        <Grid
          appConfig={{
            storage_key: 'incomplete-surveys',
            query_entity: 'instances',
            no_data_text: 'No incomplete surveys at this time.',
            fetching_data_text: 'Fetching incomplete surveys.',
            enablePagination: true,
            showCurrentPage: false,
            searchFields: ['surveyName', 'surveyDescription'],
            initialState: {
              pageSize: 5,
              sortBy: 'dateCreated.seconds',
              sortOrder: 'descending',
            },
          }}
          queryParams={{
            resultsPerPage: 5,
            page: 0,
          }}
          actions={{
            onFetch: getIncompleteSurveyInstances,
          }}
          customComponent={(item: InstanceShort.AsObject | any) => (
            <IncompleteSurveys {...item} />
          )}
        />
      ),
    },
  ]

  useEffect(() => {
    location?.pathname.includes('list') &&
      !location?.pathname.includes('complete') &&
      navigate.push('/list/complete')
  }, [])

  useEffect(() => {
    location?.pathname.includes('list') &&
      !location?.pathname.includes('complete') &&
      navigate.push('/list/complete')
  }, [location.pathname])

  return (
    <Container
      direction='column'
      height='full'
      centerX
      className='survey-tab-list outer-container overflow-y px-1-at-600 padding--x-2 px-1-at-762'
    >
      <Switch>
        <Route exact path={`${path}/complete/:surveyAttemptGuid`}>
          <VideoResponse />
        </Route>
        <Route path={path}>
          <Container
            height='full'
            direction='column'
            centerX
            className='survey-tab-list--inner-container inner-container'
          >
            <Tabs tabItems={tabItems} component={component} />
          </Container>
        </Route>
      </Switch>
    </Container>
  )
}

export default MainTabSurvey
